import { render } from "./edit.vue?vue&type=template&id=9d057188&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=9d057188&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d057188"]])

export default __exports__